import { PressReleasesItem } from '@brandhub/types/brandhub';
import Button from '@semcore/ui/button';
import Modal from '@semcore/ui/modal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SelectPressReleaseModalContent } from './SelectPressReleaseModalContent';

interface SelectPressReleaseModalProps {
  isVisible: boolean;
  onClose: () => void;
  onSelect: (pressRelease: PressReleasesItem) => void;
}

export const SelectPressReleaseModal = ({
  isVisible,
  onClose,
  onSelect,
}: SelectPressReleaseModalProps) => {
  const { t } = useTranslation(['common', 'mailingCreator']);

  const [selectedPressRelease, setSelectedPressRelease] = useState<PressReleasesItem | null>(null);

  const handleClose = () => {
    onClose();
    setSelectedPressRelease(null);
  };

  const handlePressReleaseSelect = () => {
    if (selectedPressRelease) {
      onSelect(selectedPressRelease);
    }
  };

  return (
    <Modal
      className="flex h-[600px] max-h-[calc(100vh-5rem)] w-2xl max-w-full flex-col overflow-hidden"
      visible={isVisible}
      onClose={handleClose}>
      <Modal.Title className="mb-4">
        {t('mailingCreator:aiDraftMailingModal.publishedPressRelease.select')}
      </Modal.Title>
      <SelectPressReleaseModalContent
        selectedPressRelease={selectedPressRelease}
        onSelectedPressReleaseChange={setSelectedPressRelease}
      />
      <div className="mt-6 flex items-center gap-3">
        <Button
          data-test="add-button"
          disabled={!selectedPressRelease}
          size="l"
          use="primary"
          onClick={handlePressReleaseSelect}>
          {t('common:add')}
        </Button>
        <Button
          data-test="cancel-button"
          size="l"
          onClick={handleClose}>
          {t('common:cancel')}
        </Button>
      </div>
    </Modal>
  );
};
